import { Component } from '@angular/core';
import { isTabView } from '../../utils';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthServiceHelper } from '../../providers/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@gooru/navigator-auth-widget-ui';
import { HttpService } from '@gooru/navigator-core-widget-ui';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  public isTabView: any;
  public form: FormGroup;
  public emailVal: string = '';
  public submitted: boolean = false;
  public token: any;
  public tenantId: any;
  public resetMailsent: boolean = false;
  public userNotFound: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private authServiceHelper: AuthServiceHelper,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private httpService: HttpService,
    private router: Router
  ) {
    this.isTabView = isTabView();
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  // -------------------------------------------------------------------------
  // Events
  public ngOnInit() {
    this.resetMailsent = false;
    this.token = this.activatedRoute.snapshot.queryParams['token'];
    this.tenantId = this.activatedRoute.snapshot.queryParams['tenantId'];
  }

  get emailControl() {
    return this.form.get('email');
  }

  /**
   * @function submitForm
   * this Method is used to submit the form
   */
  public submitForm() {
    if (this.form.valid) {
      this.submitted = true;
      const email = this.form.value.email;
      this.authServiceHelper
        .searchUser(email, this.token)
        .then(() => {
          this.authServiceHelper
            .resetPassword(this.tenantId, email, this.token)
            .then(() => {
              this.resetMailsent = true;
            });
        })
        .catch(() => {
          this.userNotFound = true;
        });
    } else {
      this.submitted = true;
    }
  }

  /**
   * @function onKeyDown
   * this Method is used to handle enter key press
   */
  public onKeyDown(event: any) {
    this.userNotFound = false;
    this.resetMailsent = false;
    if (event.key === 'Enter') {
      this.submitForm();
    }
  }

  /**
   * @function goBack
   * this Method is navigates back to the login page
   */
  public goBack() {
    this.router.navigate(['login']);
  }
}
